import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ib-input-field"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "ib-submit-btn" }
const _hoisted_4 = {
  key: 0,
  class: "ib-summary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_input = _resolveComponent("select-input")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_requirements_to_participate = _resolveComponent("requirements-to-participate")!
  const _component_custom_field = _resolveComponent("custom-field")!
  const _component_progress_button = _resolveComponent("progress-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createBlock(_component_info_box, {
    isActive: _ctx.isActive,
    onOnEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onEdit'))),
    canEdit: _ctx.canEdit
  }, {
    title: _withCtx(() => _cache[4] || (_cache[4] = [
      _createElementVNode("span", { class: "ib-title" }, "Additional Information", -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        class: "ib-form",
        onSubmit: _ctx.onSubmit,
        autocomplete: "off"
      }, {
        default: _withCtx(({ validate }) => [
          (_ctx.heardAboutOptions.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Heard About Us", -1)),
                _createVNode(_component_Field, {
                  name: "heardAboutUs",
                  rules: _ctx.heardAboutUsValid
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_input, {
                      options: _ctx.heardAboutOptions,
                      modelValue: _ctx.customer.ClientLocationHeardAboutUsKey,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer.ClientLocationHeardAboutUsKey) = $event))
                    }, null, 8, ["options", "modelValue"]),
                    _withDirectives(_createVNode(_component_text_input, {
                      name: 'heardAboutOther',
                      validators: [_ctx.heardAboutUsOtherValid],
                      error: "Please enter how you heard about us.",
                      modelValue: _ctx.customer.HeardAboutUsOther,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer.HeardAboutUsOther) = $event)),
                      placeholder: 'How did you hear about us?'
                    }, null, 8, ["validators", "modelValue"]), [
                      [_vShow, _ctx.customer.ClientLocationHeardAboutUsKey == 0]
                    ])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_ErrorMessage, { name: "heardAboutUs" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("div", { class: "error" }, "Please select how you heard about us.", -1)
                  ])),
                  _: 1,
                  __: [5]
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeOrder?.requirements.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_Field, {
                  name: "agreed",
                  rules: _ctx.isAgreed
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_requirements_to_participate)
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_ErrorMessage, { name: "agreed" }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "error" }, "You must agree to the requirements to participate to continue.", -1)
                  ])),
                  _: 1,
                  __: [7]
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields, (field, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "ib-input-field",
              key: field.ClientLocationCustomFieldKey
            }, [
              _createVNode(_component_custom_field, {
                modelValue: _ctx.customFields[i],
                "onUpdate:modelValue": ($event: any) => ((_ctx.customFields[i]) = $event),
                fieldKey: `${field.ClientLocationCustomFieldKey}-${i}`
              }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldKey"])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_progress_button, {
              showLoader: _ctx.loading,
              onClick: validate
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Next", -1)
              ])),
              _: 2,
              __: [8]
            }, 1032, ["showLoader", "onClick"]),
            (_ctx.canSkipSection)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "action-btn highlight-text",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                }, "Skip"))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    summary: _withCtx(() => [
      (_ctx.summaryFields.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryFields, (fields, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ib-input-field flex-col",
                key: i
              }, [
                _createElementVNode("span", null, _toDisplayString(fields.field), 1),
                _createElementVNode("span", null, _toDisplayString(fields.response), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isActive", "canEdit"]))
}